module.exports = __webpack_public_path__ + "img/什么是古树.fbd8df2e.jpg";